<template>
    <div>
        <question :text="$t(item.text, privacyPolicyLink)" />
        <div class="mb-2" style="font-weight: normal;"v-html="$t(inputLabel)" />
        <text-input
          @change="handleChange"
          :validator="validate"
          :error-text="errorText"
        />

        <hr class="text-item__gdpr-delimiter" />
        <div class="text-item__gdpr-additional-info" v-html="$t(additionalInfoKey, privacyPolicyLink)" />
        <span class="text-item__gdpr-collapse-link" @click="toggleCollapse" v-html="$t(collapseLinkKey, privacyPolicyLink)" />
        <div v-if="!collapsed" class="text-item__gdpr-collapse-text" v-html="$t(collapseTextKey, privacyPolicyLink)" />
    </div>
</template>
<script>
import textInput from '@/components/inputs/text';
import question from '@/components/ui/question';
import { mapGetters } from 'vuex'

export default {
  name: 'textInputGdprItem',
  components: {
    question,
    textInput,
  },
  props: {
    item: {
      type: Object,
    },
    itemProperties: {
      type: Object,
    },
    interactionInstanceToken: {
      type: String,
    },
    productType: {
      type: String
    },
    minLength: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    ...mapGetters([
      'locales',
    ]),
    errorText() {
      return this.$t(`${this.item.text}_TEXT_VAL_ERROR`);
    },
    additionalInfoKey() {
      return `${this.item.text}_ADDITIONAL_INFO`;
    },
    collapseLinkKey() {
      return `${this.item.text}_COLLAPSE_LINK`;
    },
    collapseTextKey() {
      return `${this.item.text}_COLLAPSE_TEXT`;
    },
    inputLabel() {
      return `${this.item.text}_INPUT_LABEL`;
    },
    privacyPolicyLink() {
      const result = {};
      this.locales
        .filter(locale => !locale.hidden)
        .forEach(locale => {
          const langKey = locale.language.toLowerCase();
          const localeId = locale.id;

          result[`privacy_policy_link_${langKey}`] = `/i/${this.interactionInstanceToken}/privacy-policy?product=${this.productType}&locale=${localeId}`;
        });

      return result;
    },
  },
  data() {
    return {
      collapsed: true,
    };
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    handleChange(textInput) {
      if (textInput) {
        this.$emit('answer', {
          ...this.item,
          result: 1,
          data: [
            {
              key: 'TEXT',
              value: textInput,
            },
          ],
        });
      } else {
        this.$emit('answer', null);
      }
    },
    validate(input) {
      return input.length >= this.minLength;
    },
  },
};
</script>
<style lang="scss">
.text-item__gdpr-delimiter {
  margin: 1.5em 0 1em;
  border: none;
  border-top: 1px solid $main-font-grey;
}

.text-item__gdpr-additional-info {
  margin-bottom: 0.5em;
}

.text-item__gdpr-collapse-link {
  display: inline-block;
  color: $bq-green;
  margin-bottom: 0.5em;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.text-item__gdpr-collapse-text {
  border: 1px solid $base_grey-2;
  border-radius: 8px;
  background-color: $base_grey-3;
  padding: 1em;
}

.text-input {
  min-height: unset;
}
</style>
